export const getMediaEmbed = ({ baseURL, uuid }) => {
  const embedUrl = `${baseURL}/embed/${uuid}`;
  return `<iframe width="100%" height="560" style="background-color:#000" id="okast_player_iframe" src="${embedUrl}" frameborder="0" allowfullscreen></iframe>`;
};
